import { generateFontSizing } from 'app/styles/mixins';
import { lineHeightsMobile, media } from 'app/styles/variables';
import styled, { css } from 'styled-components';

export const MakeTitleWrapperSt = styled.div`
  margin-top: 1rem;
  margin-bottom: 1rem;

  ${media.sm(css`
    margin-top: 1.5rem;
    margin-bottom: 2rem;
  `)}

  ${media.md(css`
    margin-top: 3rem;
    margin-bottom: 3rem;
  `)}
`;

export const MakeIconSt = styled.img`
  display: inline-block;
  max-height: 100%;
  width: 2rem;
  margin-right: 0.5rem;
  margin-top: -1.25rem;

  line-height: ${lineHeightsMobile.h1};

  ${media.sm(css`
    margin-right: 0.75rem;
    width: 3.5rem;
  `)}
`;

export const MakeHeadingSt = styled.h1`
  display: inline-block;
  ${generateFontSizing('h1')}
  margin: 0;
`;
